<div class="scaled-125">
  <nav class="navbar-bg" [ngClass]="{ 'no-border': isRowVisible }">
    <div class="section">
      <div
        class="header-class"
        [ngStyle]="{
          height:
            pageSource !== 'Home' && pageSource !== 'Preview' ? '4.5em' : '4em',
          'background-color':
            pageSource !== 'Home' ? 'rgba(31, 54, 199, 0.7)' : 'transparent',
          'background-blend-mode': pageSource !== 'Home' ? 'overlay' : 'normal'
        }"
      >
        <div class="overlay-content">
          <img
            src="/assets/images/icons/home.svg"
            class="icon home-icon"
            alt="home-icon"
          />
          <img
            src="/assets/images/icons/dropdown.svg"
            class="icon dropdown-icon"
            [matMenuTriggerFor]="beforeMenu"
            alt="dropdown-icon"
          />

          <mat-menu
            #beforeMenu="matMenu"
            xPosition="before"
            [overlapTrigger]="false"
            panelClass="custom-menu-panel"
          >
            <span
              ><a [href]="rdUrl" target="_blank" class="divider-designation"
                >R&D Assistant</a
              ></span
            >
          </mat-menu>

          <span class="overlay-text" *ngIf="showBreadcrumbs">
            <app-breadcrumbs [routeData]="pageData"></app-breadcrumbs>
          </span>
        </div>

        <!-- Right User Info -->
        <div class="user-details">
          @if(pageSource != 'Home'&& pageSource !== 'Editclaims'){
          <div class="info-container">
            <div class="info-column">
              <div class="info-row">
                <span class="label">Project</span>
                <!-- <span class="value">{{ projectValue }}</span> -->
                <a href="{{ projectLink }}" class="value" target="_blank">{{
                  projectValue
                }}</a>
              </div>
              <div class="info-row">
                <span class="label">Product</span>
                <!-- <span class="value">{{ productValue }}</span> -->
                <a href="{{ productLink }}" class="value" target="_blank">{{
                  productValue
                }}</a>
              </div>
            </div>

            <div class="info-column">
              <div class="info-row">
                <span class="label">Geography</span>
                <span class="value">{{ geographyValue }}</span>
              </div>
              <div class="info-row">
                <span class="label">Language</span>
                <span class="value">{{ languageValue }}</span>

                <!-- <input
                [disabled]="true"
                class="language-dropdown cursor-not-allowed"
                type="text"
                [value]="languageValue"
              /> -->
                <!-- <select class="language-dropdown">
                <option>English</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select> -->
              </div>
            </div>
          </div>
          } @if(pageSource === 'Editclaims'){
          <div class="info-container">
            <div class="info-column">
              <div class="info-row">
                <span class="label">Project</span>
                <span class="value">{{ projectValue }}</span>
                <!-- <span class="value">{{
                  projectValue.length > 30
                    ? (projectValue | slice : 0 : 30) + "..."
                    : projectValue
                }}</span> -->
              </div>
              <div class="info-row">
                <span class="label">Product</span>
                <div class="product-wrapper">
                  <p-dropdown
                    [options]="productsData"
                    [(ngModel)]="selectedProduct"
                    [matTooltip]="selectedProductTitle"
                    optionLabel="product_title"
                    optionValue="product__v"
                    placeholder="Select"
                    appendTo="body"
                    class="product-dropdown"
                    (onChange)="getSelectedProduct($event)"
                  ></p-dropdown>

                  <img
                    *ngIf="selectedProduct"
                    src="/assets/images/icons/close-icon-white.svg"
                    class="close-icon"
                    alt="close-icon"
                    (click)="clearSelectedProduct()"
                  />
                </div>
              </div>
            </div>

            <div class="info-row geography-row">
              <span class="geography-label">Geography</span>
              <p-dropdown
                [options]="geographyData"
                [(ngModel)]="selectedGeography"
                optionLabel="country_name"
                optionValue="country__v"
                [matTooltip]="selectedGeographyName"
                placeholder="Select"
                appendTo="body"
                (onChange)="getSelectedGeography($event)"
                class="geography-dropdown-edit"
              ></p-dropdown>

              <img
                *ngIf="selectedGeography"
                src="/assets/images/icons/close-icon-white.svg"
                class="close-icon"
                alt="close-icon"
                style="margin-bottom: 9px"
                (click)="clearSelectedGeography()"
              />

              <button
                mat-flat-button
                class="load-button"
                (click)="loadTableData()"
                [disabled]="selectedProduct == null"
                [ngClass]="{
                  'common-disabled-colour': selectedProduct == null
                }"
              >
                Load
              </button>
            </div>
          </div>
          }

          <span class="username-class">Hi {{ loggedInUser | titlecase }}</span>
          <img
            src="/assets/images/icons/profile.svg"
            class="icon profile-icon"
            alt="profile-icon"
            [matMenuTriggerFor]="beforeIcon"
          />

          <mat-menu #beforeIcon="matMenu" xPosition="after" class="custom-menu">
            <a [href]="faq" target="_blank">
              <div class="divider-sec">
                <img
                  src="/assets/images/icons/help.svg"
                  class="icon"
                  alt="help-icon"
                />
                <span class="divider-font">Training Material</span>
              </div>
            </a>
            <a [href]="claimSupport" target="_blank">
              <div class="divider-sec">
                <img
                  src="/assets/images/icons/claim_group.svg"
                  class="icon"
                  alt="claims-icon"
                />
                <span class="divider-font">Claims Support Group</span>
              </div>
            </a>
            <a [href]="raiseIncident" target="_blank">
              <div class="divider-sec">
                <img
                  src="/assets/images/icons/contact.svg"
                  class="icon"
                  alt="contact-icon"
                />
                <span class="divider-font">Raise an Incident</span>
              </div>
            </a>
            <div class="divider-sec" (click)="logout()">
              <img
                src="/assets/images/icons/logout.svg"
                class="icon"
                alt="logout-icon"
              />
              <span class="divider-font">Logout</span>
            </div>
          </mat-menu>

          <!-- <div class="notification-wrapper">
            <button
              mat-icon-button
              (click)="togglePanel()"
              [matMenuTriggerFor]="menu"
            >
              <img
                src="/assets/images/icons/notification.svg"
                class="icon notification-icon"
                alt="notification-icon"
              />
              
            </button>

            <span *ngIf="hasNew" class="notification-dot"></span>

            <mat-menu
              #menu="matMenu"
              xPosition="before"
              [overlapTrigger]="false"
              panelClass="custom-menu-panel"
            >
              <div
                *ngFor="let note of notifications"
                (click)="openDetails(note)"
                class="notification-item divider-sec"
              >
                <div>
                  <span class="notification-status">Submitted Successfully</span
                  ><br />
                  <span class="notification-summary"> {{ note.summary }} </span
                  ><br />
                  <span class="notification-summary">{{ note.timestamp }}</span>
                </div>
              </div>
            </mat-menu>
          </div> -->

          <!-- header.component.html -->
          <div
            class="notification-wrapper"
            appAppclosenotification
            (appClickOutside)="onNotificationClickOutside()"
          >
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              #menuTrigger="matMenuTrigger"
              (click)="togglePanel()"
            >
              <img
                src="/assets/images/icons/notification.svg"
                class="icon notification-icon"
                alt="notification-icon"
              />
              <span *ngIf="hasNew" class="notification-dot"></span>
            </button>

            <!-- <mat-menu #menu="matMenu" panelClass="custom-menu-panel"> -->
            <mat-menu
              #menu="matMenu"
              panelClass="custom-menu-panel"
              [hasBackdrop]="false"
            >
              <ng-container *ngIf="showNotificationPanel ; else loadNotinfications">
                <ng-container
                *ngIf="notifications.length > 0; else noNotifications"
              >
                <div
                  *ngFor="let note of notifications"
                  (click)="$event.stopPropagation()"
                  class="notification-item divider-sec"
                >
                  <div class="notify-style">
                    <span class="notification-status"
                      >Submitted Successfully</span
                    ><br />
                    <span
                      class="notification-summary"
                      (click)="openDetails(note)"
                      >{{ note.summary }}</span
                    ><br />
                    <span class="notification-summary notification-timestamp"
                      >{{ note.timestamp }}
                    </span>
                    <span>
                      <!-- <button (click)="markAsRead(note)">
                        Mark as Read
                      </button> -->
                      <img
                        *ngIf="note.view_status == 'NO'"
                        style="
                          height: 12px;
                          background-color: white;
                          margin-top: -12px;
                          margin-left: 90%;
                        "
                        src="/assets/images/icons/check-mark-not-seen-white-bg.png"
                        alt="mark as read"
                        (click)="markAsRead(note); $event.stopPropagation()"
                      />
                      <img
                        *ngIf="note.view_status == 'YES'"
                        style="
                          height: 12px;
                          background-color: white;
                          margin-top: -12px;
                          margin-left: 90%;
                        "
                        src="/assets/images/icons/check-mark-seen-white-bg.png"
                        alt="mark as read"
                      />
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-template #noNotifications>
                <div class="notification-item">No notifications available.</div>
              </ng-template>
              </ng-container>
              <ng-template #loadNotinfications><div class="notification-item">Loading...</div></ng-template>
              
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
<router-outlet></router-outlet>
